import { redirectToFallback } from "@delorean/utils/securityUtils";
import {
  AUTHORIZE_REQUEST,
  AUTHORIZE_SUCCESS,
  AUTHORIZE_FAILURE,
  AuthorizeActionTypes,
  AUTHORIZE_REQUEST_EXPIRED,
  SET_POLL_ABORT_CONTROLLER,
  ABORT_POLLING,
  AUTHORIZE_SESSION_EXPIRED,
} from "../actions/authorizeActions";

interface AuthorizeState {
  loading: boolean;
  data: any | null;
  error: string | null;
  pollAbortController: AbortController | null;
}

const initialState: AuthorizeState = {
  loading: false,
  data: null,
  error: null,
  pollAbortController: null,
};

export const authorizeReducer = (
  state = initialState,
  action: AuthorizeActionTypes | any
): AuthorizeState => {
  switch (action.type) {
    case AUTHORIZE_REQUEST:
      return { ...state, loading: true, error: null };
    case AUTHORIZE_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case AUTHORIZE_FAILURE:
      return { ...state, loading: false, error: action.error };
    case AUTHORIZE_REQUEST_EXPIRED:
      return { ...state, loading: false, error: null };
    case SET_POLL_ABORT_CONTROLLER:
      // Se c'era un polling precedente, abortiscilo
      if (state.pollAbortController) {
        state.pollAbortController.abort();
      }
      return { ...state, pollAbortController: action.payload };
    case ABORT_POLLING:
      // Abortisci il polling corrente
      if (state.pollAbortController) {
        state.pollAbortController.abort();
      }
      return { ...state, pollAbortController: null };
    case AUTHORIZE_SESSION_EXPIRED:
       redirectToFallback("Session expired from AUTH flow");
      return { ...state, error: action.error };
    default:
      return state;
  }
};
